import React from 'react'
import { Icon, SemanticICONS } from 'semantic-ui-react'

const icons: { [key: number]: Partial<SemanticICONS> } = {
  1: 'food',
  2: 'car',
  3: 'medkit',
  4: 'cart',
}

const CategoryIcon = ({
  category,
  ...rest
}: {
  category: number | string
} & React.ComponentProps<typeof Icon>) => (
  <Icon name={icons[category] ?? 'question'} {...rest} />
)

export default CategoryIcon
